import React, { useState } from 'react'
import { HeroIcons } from '../../../../lib/utils/heroIcons'
import { useTranslation } from 'next-i18next'
import useLocale from '../../../../hooks/useLocale'
import { PropertyNew } from '../../../../types/Property/Property'

type Props = {
  news: PropertyNew[]
}

export default function PropertyNews({ news }: Props) {
  const { t } = useTranslation('originals/property')
  const { locale } = useLocale()
  const [currentIndex, setCurrentIndex] = useState(0)

  const handlePrev = () => {
    if (currentIndex < news.length - 1) {
      setCurrentIndex(currentIndex + 1)
    }
  }

  const handleNext = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  }

  if (news.length < 1) return null

  return (
    <div className="mb-4 mt-2 rounded-2xl border border-brandLightestBlue bg-white px-4 py-5">
      <div className="mb-2 flex justify-between">
        <h2 className="font-bold text-neutralBlack">
          {t('infoSection.news.title')}
        </h2>
        <div>
          <button
            onClick={handlePrev}
            disabled={currentIndex === news.length - 1 || news.length === 0}
            className={`mr-2 rounded-full p-1 ${
              currentIndex === news.length - 1 || news.length === 0
                ? 'text-gray-400'
                : 'hover:bg-gray-200'
            }`}
          >
            <HeroIcons.ArrowLeftIcon className="h-5 w-5" aria-hidden="true" />
          </button>
          <button
            onClick={handleNext}
            disabled={currentIndex === 0}
            className={`rounded-full p-1 ${
              currentIndex === 0 ? 'text-gray-400' : 'hover:bg-gray-200'
            }`}
          >
            <HeroIcons.ArrowRightIcon className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>
      {news.length > 0 && (
        <p className="capitalize">
          {new Date(news[currentIndex].newsDate).toLocaleDateString(locale, {
            month: 'long',
            year: 'numeric',
          })}
        </p>
      )}
      <p className="text-sm font-light">
        {news.length > 0 && news[currentIndex].translation.content}
      </p>
    </div>
  )
}
